import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSegaComponent } from './simple-icons-sega.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSegaComponent ],
    exports:      [ SimpleIconsSegaComponent ],
    bootstrap:    []
})
export class SimpleIconsSegaModule {}
